import LinkWithIcon from "./LinkWithIcon";

const FlightBriefCrew = ({ briefData }) => {
    return (
        <div className="flight-brief__content-grid flight-brief__content-grid--people">
            <div>
                <div className="flight-brief__gold-title">Pilot in command</div>
                <div className="flight-brief__dark-title">{briefData.pilotName ? briefData.pilotName : "TBC"}</div>
                {briefData.pilotName && briefData.pilotPhone && (
                    <div className="flight-brief__body-text">
                        <LinkWithIcon link="tel:{briefData.pilotPhone}" icon="phone">
                            {briefData.pilotPhone}
                        </LinkWithIcon>
                    </div>
                )}
            </div>

            <div>
                <div className="flight-brief__gold-title">Second in command</div>
                <div className="flight-brief__dark-title">
                    {briefData.firstOfficerName ? briefData.firstOfficerName : "TBC"}
                </div>
                {briefData.firstOfficerName && briefData.firstOfficerPhone && (
                    <div className="flight-brief__body-text">
                        <LinkWithIcon link="tel:{briefData.firstOfficerPhone}" icon="phone">
                            {briefData.firstOfficerPhone}
                        </LinkWithIcon>
                    </div>
                )}
            </div>

            <div>
                <div className="flight-brief__gold-title">Flight attendant</div>
                <div className="flight-brief__dark-title">
                    {briefData.flightAttendantName ? briefData.flightAttendantName : "TBC"}
                </div>
                {briefData.flightAttendantName && briefData.flightAttendantPhone && (
                    <div className="flight-brief__body-text">
                        <LinkWithIcon link="tel:{briefData.flightAttendantPhone}" icon="phone">
                            {briefData.flightAttendantPhone}
                        </LinkWithIcon>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FlightBriefCrew;
